import React, { useEffect, useRef, useState } from 'react';
import { Alert } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import HeaderNavbar from '../components/HeaderNavbar';
import Footer from '../components/Footer';
import Spinner from 'react-bootstrap/Spinner';
import config from '../config';
import api from '../lib/request';
import './Login.css';

const VerifyAccount = () => {
  const { token } = useParams();
  const [status, setStatus] = useState('loading'); // loading | success | already | error
  const [message, setMessage] = useState('');
  const hasCalledAPI = useRef(false);

  useEffect(() => {
    if (hasCalledAPI.current) {
      return;
    }
    hasCalledAPI.current = true;
    if (!token) {
      setStatus('error');
      setMessage('Missing verification token.');
      return;
    }

    setStatus('loading');
    setMessage('');

    const verify = async () => {
      try {
        const response = await api.post(`/api/v1/auth/register/verify/${token}`, {});
        if (response?.alreadyVerified) {
          setStatus('already');
          setMessage('Your account is already verified. You can Log in now.');
        } else if (response?.verified){
          setStatus('success');
          setMessage('Your account is verified. You can Log in now.');
        } else {
          setStatus('error');
          setMessage('We could not verify your account. The link may be invalid or expired.');
        }
      } catch (err) {
        const reasons = Array.isArray(err?.reasons) && err.reasons.length ? ` ${err.reasons.join(' ')}` : '';
        setStatus('error');
        setMessage(err?.message ? `${err.message}${reasons}` : 'We could not verify your account. The link may be invalid or expired.');
      }
    };

    verify();

    return;
  }, [token]);

  const renderContent = () => {
    if (status === 'loading') {
      return (
        <div className="Auth-form auth-account-form">
          <div className="Auth-form-content" style={{ textAlign: 'center' }}>
            <div style={{display: 'flex', justifyContent: 'center', marginBottom: 10}}>
              <img src="/logo.svg" alt="Logo" width="100" height="100" />
            </div>
            <Spinner animation="border" />
            <div className="mt-2">Verifying your account...</div>
          </div>
        </div>
      );
    }

    if (status === 'success' || status === 'already') {
      return (
        <div className="Auth-form auth-account-form">
          <div className="Auth-form-content" style={{ textAlign: 'center' }}>
            <div style={{display: 'flex', justifyContent: 'center', marginBottom: 10}}>
              <img src="/logo.svg" alt="Logo" width="100" height="100" />
            </div>
            <Alert variant="success">{message}</Alert>
            <div className="text-center mt-2">
              <Link to={`${config.prefixPath}/login`} className="btn btn-link">Log in</Link>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="Auth-form auth-account-form">
        <div className="Auth-form-content" style={{ textAlign: 'center' }}>
          <div style={{display: 'flex', justifyContent: 'center', marginBottom: 10}}>
            <img src="/logo.svg" alt="Logo" width="100" height="100" />
          </div>
          <Alert variant="danger">{message || 'Unable to verify your account.'}</Alert>
          <p className="mt-2">
            Need help? Contact support or try registering again to receive a new verification email.
          </p>
          <div className="text-center mt-2">
            <Link to={`${config.prefixPath}/register`} className="btn btn-link">Back to registration</Link>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <HeaderNavbar />
      <div className="row">
        <div className="Auth-form-container">
          {renderContent()}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default VerifyAccount;
